import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import Save from './save';
import metadata from "./block.json";
import { spacingAttributes } from '../../utils/spacingAttributes';

registerBlockType(metadata.name, {
  attributes: {
    ...metadata.attributes,
    ...spacingAttributes
  },
  edit: Edit,
  save: Save,
});